module.exports = __webpack_public_path__ + "static/media/wifi_thermostat.f47a38d2.png";